import { lazy } from 'react';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import AuthGuard from 'utils/route-guard/AuthGuard';
import NewCampaignLayout from 'layout/NewCampaignLayout';
import Loadable from 'ui-component/Loadable';

// sample page routing
const NewCampaignPage = Loadable(lazy(() => import('views/archive/new-campaign-page')));

// ==============================|| MAIN ROUTING ||============================== //

const NewCampaignRoutes = {
    path: '/',
    element: (
        <NavigationScroll>
            <AuthGuard>
                <NewCampaignLayout />
            </AuthGuard>
        </NavigationScroll>
    ),
    children: [
        {
            path: '/new-campaign/old',
            element: <NewCampaignPage />
        }
    ]
};

export default NewCampaignRoutes;
